/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Delete_ProductInputs */

const en_lifecycle_delete_product = /** @type {(inputs: Lifecycle_Delete_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete product`)
};

const de_lifecycle_delete_product = /** @type {(inputs: Lifecycle_Delete_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt löschen`)
};

/**
* | output |
* | --- |
* | "Delete product" |
*
* @param {Lifecycle_Delete_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_product = /** @type {((inputs?: Lifecycle_Delete_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_product(inputs)
	return en_lifecycle_delete_product(inputs)
});